import Service, { getCallApiFunction } from '../service'
import denormalizer from './denormalizer'
// import normalizer from './normalizer'

export type ParamsType = {
  queryLiveTime?: Date
  pageSize: number
  pageNo: number
  liveTypes?: any
  /** 直播間模式篩選（ROOM_MODE），不帶 = 全部 */
  roomMode?: number
}

class FetchLiveListApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_LIVE_LIST'

    this.config = {
      url: `/v1/room/list`,
      method: 'GET',
      params,
    }

    this.denormalizer = denormalizer
  }
}

export const fetchLiveList = (params: ParamsType) => getCallApiFunction(new FetchLiveListApi(params))
